import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ModuleName } from '../../core-data-model';
import {
    FeatureFlags,
    FeatureFlagsService,
    ModuleAccessService,
    ModuleUserAccessService
} from '../../system-services';
import { TemplateType } from './internal-activations-error-template/internal-activations-error-template.component';

@Component({
    template: `
        @if (selectErrorTemplate) {
            <internal-activations-error-template
                [templateType]="errorTemplate"
            ></internal-activations-error-template>
        } @else {
            <internal-activations-page></internal-activations-page>
        }
    `,
    standalone: false
})
export class InternalActivationsContainerComponent implements OnInit {
    softwareModule: string;
    selectErrorTemplate = false;
    errorTemplate: TemplateType = TemplateType.Unknown;

    constructor(
        private moduleAccessService: ModuleAccessService,
        private featureFlags: FeatureFlagsService,
        private route: ActivatedRoute,
        private moduleUserAccessService: ModuleUserAccessService
    ) {}

    ngOnInit() {
        this.route.paramMap.subscribe((params) => {
            this.softwareModule = params.get('module')?.toLowerCase();
        });

        this.selectErrorTemplate =
            this.isPaidInspireAccount() ||
            this.isInspireTimeTrialExpired() ||
            this.isHireTimeTrialExpired() ||
            this.isDiagnoseTimeTrialExpired() ||
            this.isPerformNoUserAccess();
        if (this.selectErrorTemplate) {
            this.setErrorTemplate();
        }
    }

    private setErrorTemplate(): void {
        if (this.isPaidInspireAccount()) {
            this.errorTemplate = TemplateType.Paid;
        }

        if (
            this.isInspireTimeTrialExpired() ||
            this.isHireTimeTrialExpired() ||
            this.isDiagnoseTimeTrialExpired()
        ) {
            this.errorTemplate = TemplateType.TimeTrialExpired;
        }

        if (this.isPerformNoUserAccess()) {
            this.errorTemplate = TemplateType.NoUserAccess;
        }
    }

    private isPaidAccount(): boolean {
        return this.moduleAccessService.isPaidAccount(this.getModuleName());
    }

    private isTimeTrialExpired(): boolean {
        return this.moduleAccessService.isTimeTrialExpired(
            this.getModuleName()
        );
    }

    private isPaidInspireAccount(): boolean {
        return this.isPaidAccount() && this.softwareModule === 'inspire';
    }

    private isInspireTimeTrialExpired(): boolean {
        return this.isTimeTrialExpired() && this.softwareModule === 'inspire';
    }

    private isHireTimeTrialExpired(): boolean {
        return (
            this.isTimeTrialExpired() &&
            this.softwareModule === 'hire' &&
            this.featureFlags.getByFlag(FeatureFlags.enableHire2TimeTrialGuard)
        );
    }

    private isDiagnoseTimeTrialExpired(): boolean {
        return this.isTimeTrialExpired() && this.softwareModule === 'diagnose';
    }

    private isPerformNoUserAccess(): boolean {
        return (
            !this.moduleUserAccessService.hasBasicPerformPermissions() &&
            this.softwareModule === 'perform'
        );
    }

    private getModuleName(): ModuleName {
        switch (this.softwareModule) {
            case 'design':
                return ModuleName.Design2;
            case 'hire':
                return ModuleName.HireHero;
            case 'inspire':
                return ModuleName.Inspire2;
            case 'diagnose':
                return ModuleName.Diagnose2;
            case 'perform':
                return ModuleName.Perform;
            default:
                return ModuleName.Unknown;
        }
    }
}
